import { ApiService } from "./types";

// ─── Static Data ─────────────────────────────────────────────────────────────

export const OFFLINE_RESPONSE_ITEM = {
  dadosCadastrais: {
    nome: "string",
    cpf: "string",
    dataNascimento: "string",
    nb: "string",
    situacao: "string",
    dib: "string",
    ddb: "string",
    nomeMae: "string",
    rg: "string",
    sexo: "string",
    especie: "string",
    pensaoAlimenticia: true,
    representanteLegal: true,
    bloqueadoEmprestimo: true,
    permiteEmprestimo: true,
    uf: "string",
    ufBeneficio: "string",
    endereco: "string",
    bairro: "string",
    cidade: "string",
    cep: "string"
  },
  dadosMargens: {
    valorBeneficio: 0.0,
    baseCalculo: 0.0,
    margemDisponivelEmprestimo: 0.0,
    margemDisponivelRmc: 0.0,
    margemDisponivelRcc: 0.0,
    qtdEmprestimos: 0,
    totalParcelas: 0.0,
    totalContratos: 0.0,
    possuiCartao: true,
    descontoAssociacao: 0.0
  },
  dadosRepresentanteLegal: {},
  dadosBancario: {
    agenciaPgto: "string",
    agencia: "string",
    banco: "string",
    contaPgto: "string",
    meioPagamento: "string"
  },
  emprestimosRmc: [
    {
      banco: "string",
      nomeBanco: "string",
      valor: 0.0,
      valorParcela: 0.0,
      contrato: "string",
      valorEmprestimo: 0.0,
      dataInclusao: "string"
    }
  ],
  emprestimosRcc: [],
  emprestimos: [
    {
      banco: "string",
      nomeBanco: "string",
      valorParcela: 0.0,
      saldoDevedor: 0.0,
      prazo: 0,
      tipoEmprestimo: "string",
      taxa: 0.0,
      parcelasRestantes: 0.0,
      contrato: "string",
      valorEmprestimo: 0.0,
      valorLiberado: 0.0,
      dataAverbacao: "string",
      dataInicioDesconto: "string",
      dataFimDesconto: "string"
    }
  ]
};

export const TELEFONIA_RESPONSE_ITEM = {
  cpf: "string",
  nomeCompleto: "string",
  dataNascimento: "string",
  idade: "string",
  nomeMae: "string",
  sexo: "string",
  emails: [
    {
      email: "string"
    }
  ],
  obito: true,
  politicamenteExposta: true,
  telefones: [
    {
      phone: "string",
      whatsApp: true
    },
    {
      phone: "string",
      whatsApp: false
    }
  ],
  endereco: {
    tipo: "string",
    titulo: "string",
    logradouro: "string",
    numero: "string",
    complemento: "string",
    bairro: "string",
    cidade: "string",
    uf: "string",
    cep: "string",
    areaRisco: true,
    latitude: "string",
    longitude: "string"
  }
}

export const SERVICES: ApiService[] = [
  {
    name: "Autenticação",
    version: "v1.0.0",
    status: "Stable",
    baseUrl: "https://novapowerhub.com.br/api",
    description:
      "Serviço responsável pela autenticação de usuários e gerenciamento de tokens JWT de acesso e refresh.",
    groups: [
      {
        tag: "Auth",
        description: "Autenticação e renovação de tokens",
        endpoints: [
          {
            method: "POST",
            path: "/auth/token",
            description: "Gera um token de acesso e refresh",
            body: {
              username: "string",
              password: "string"
            },
            response: {
              access_token: "string",
              refresh_token: "string",
              token_type: "Bearer"
            }
          },
          {
            method: "POST",
            path: "/auth/refresh",
            description: "Renova o token de acesso utilizando o refresh token",
            params: [
              {
                name: "refreshToken",
                in: "query",
                required: true,
                description: "Token de refresh válido"
              }
            ],
            response: {
              access_token: "string",
              refresh_token: "string",
              token_type: "Bearer"
            }
          }
        ]
      }
    ]
  },
  {
    name: "Consulta Offline",
    version: "v1.0.0",
    status: "Stable",
    baseUrl: "https://apiconsulta.novapowerhub.com.br/api",
    description:
      "Serviço de consulta offline de benefícios INSS. Retorna dados cadastrais, margens disponíveis, dados bancários e contratos de empréstimo.",
    groups: [
      {
        tag: "Consulta Offline",
        description: "Consulta de benefícios INSS de forma offline",
        endpoints: [
          {
            method: "GET",
            path: "/consultas/inss/offline/nb/{nb}",
            description: "Consulta dados de benefício pelo número do NB",
            headers: {
              Authorization: "Bearer {access_token}"
            },
            params: [
              {
                name: "nb",
                in: "path",
                required: true,
                description: "Número do benefício"
              }
            ],
            response: OFFLINE_RESPONSE_ITEM
          },
          {
            method: "GET",
            path: "/consultas/inss/offline/cpf/{cpf}",
            description: "Consulta todos os benefícios vinculados a um CPF",
            headers: {
              Authorization: "Bearer {access_token}"
            },
            params: [
              {
                name: "cpf",
                in: "path",
                required: true,
                description: "CPF do beneficiário"
              }
            ],
            response: [OFFLINE_RESPONSE_ITEM]
          }
        ]
      }
    ]
  },
  {
    name: "Consulta Telefonia",
    version: "v1.0.0",
    status: "Stable",
    baseUrl: "https://higienizacao.novapowerhub.com.br/api",
    description:
      "Serviço de consulta de CPF para buscar dados cadastrais e principalmente telefonia.",
    groups: [
      {
        tag: "Consulta Telefone",
        description: "Consulta de telefone de forma online",
        endpoints: [
          {
            method: "GET",
            path: "/telefonia/dados/{cpf}",
            description: "Consulta de CPF ",
            headers: {
              Authorization: "Bearer {access_token}"
            },
            params: [
              {
                name: "cpf",
                in: "path",
                required: true,
                description: "CPF do cliente"
              },
              {
                name: "whatsapp",
                in: "query",
                required: false,
                description: "Caso queira que valide a flag de WhatsApp (true/false). Padrão false"
              }
            ],
            response: TELEFONIA_RESPONSE_ITEM
          }
        ]
      }
    ]
  }
];
